import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "micro_ai",
  "use": "micro_ai-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 10\" id=\"micro_ai\"><path d=\"M4.5 1c.244 0 .463.152.548.381l.93 2.528a.19.19 0 0 0 .113.114l2.528.93a.584.584 0 0 1 0 1.095l-2.528.93a.191.191 0 0 0-.114.113l-.93 2.528a.584.584 0 0 1-1.095 0l-.93-2.528a.191.191 0 0 0-.113-.114l-2.528-.93a.584.584 0 0 1 0-1.095l2.528-.93a.191.191 0 0 0 .114-.113l.93-2.528A.584.584 0 0 1 4.5 1ZM9 0v1h1v1H9v1H8V2H7V1h1V0h1Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol